import { Title, Text, Accordion, ThemeIcon, Stack, Paper, Box, Flex } from "@mantine/core";
import { IconBook, IconSearch, IconShieldCheck, IconUsers, IconFileInvoice, IconLock } from "@tabler/icons-react";
import { faqData } from "@/components/shared/constants/general.const";

// Icon mapping
const iconMap: Record<string, any> = {
  IconBook,
  IconSearch,
  IconShieldCheck,
  IconUsers,
  IconFileInvoice,
  IconLock,
};

export default function FAQSection() {
  return (
    <Flex direction="column" align="center" py={60} px="xl" maw={1200} mx="auto" w="100%">
      <Paper radius="lg" p="xl" bg="primary.0" w="100%" maw={720}>
        <Stack align="center" gap="xl" mb={60}>
          <Title order={2} ta="center">
            Frequently Asked Questions
          </Title>
          <Text c="slate.6" size="lg" ta="center" maw={600}>
            Browse by category or search for specific topics
          </Text>
        </Stack>

        <Stack gap="lg">
          {faqData.categories.map((category) => {
            const IconComponent = iconMap[category.icon];

            return (
              <Paper key={category.id} radius="lg" bg="white" withBorder style={{ overflow: "hidden" }}>
                <Accordion variant="default" radius="lg">
                  <Accordion.Item value={category.id} style={{ borderBottom: 0 }}>
                    <Accordion.Control
                      icon={
                        <ThemeIcon size="lg" radius="lg" color="primary" variant="light">
                          <IconComponent size={20} />
                        </ThemeIcon>
                      }
                    >
                      <Text fw={600} size="lg">
                        {category.title}
                      </Text>
                    </Accordion.Control>
                    <Accordion.Panel>
                      <Box bg="gray.0" p="md">
                        <Accordion variant="separated" defaultValue={category.questions[0]?.id}>
                          {category.questions.map((question) => (
                            <Accordion.Item key={question.id} value={question.id} style={{ backgroundColor: "white" }}>
                              <Accordion.Control>{question.question}</Accordion.Control>
                              <Accordion.Panel>
                                <Text size="sm" c="slate.6" lh={1.6}>
                                  {question.answer}
                                </Text>
                              </Accordion.Panel>
                            </Accordion.Item>
                          ))}
                        </Accordion>
                      </Box>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>
              </Paper>
            );
          })}
        </Stack>
      </Paper>
    </Flex>
  );
}
